import React, { memo } from 'react'
import ZoomToStopButton from 'components/route-manager/BulkActions/common/StopListItem/ZoomToStopButton'
import { ListItem, ListItemAvatar, Stack } from '@mui/material'
import StopListItemText from 'components/route-manager/BulkActions/common/StopListItem/StopListItemText'
import { listItemSecondaryActionClasses } from '@mui/material/ListItemSecondaryAction'
import PropTypes from 'prop-types'
import { getBulkStopData } from 'components/route-manager/BulkActions/settings'
import { isRoutableStop, routableStopKindOf } from 'components/route-manager/routable/routableStopKind'

const StopListItem = ({ row, AvatarContent, showAvatarContent = true }) => {
  const { accountName, addressStr, parsedDaysOfWeek, recurrence, serviceName, showWeekSummary } = getBulkStopData(row)
  // A routable row has no account, so the primary line renders empty unless the site name takes it.
  const kind = isRoutableStop(row?.stopType) ? routableStopKindOf(row?.stopType) : null
  const primaryName = kind ? serviceName || kind.fallbackLabel : accountName
  const secondaryName = kind && serviceName ? kind.fallbackLabel : serviceName
  return (
    <ListItem
      secondaryAction={<ZoomToStopButton row={row} />}
      disableGutters
      disablePadding
      sx={{
        flex: 1,
        width: '100%',
        [`.${listItemSecondaryActionClasses.root}.${listItemSecondaryActionClasses.disableGutters}`]: { right: 8, top: 16 },
      }}
    >
      {showAvatarContent && (
        <ListItemAvatar sx={{ minWidth: 'unset' }}>
          <Stack justifyContent="center" alignItems="center">
            {AvatarContent}
          </Stack>
        </ListItemAvatar>
      )}
      <StopListItemText
        accountName={primaryName}
        serviceName={secondaryName}
        parsedDaysOfWeek={parsedDaysOfWeek}
        addressStr={addressStr}
        recurrence={recurrence}
        showWeekSummary={showWeekSummary}
      />
    </ListItem>
  )
}

StopListItem.propTypes = {
  row: PropTypes.object,
  AvatarContent: PropTypes.node,
  showAvatarContent: PropTypes.bool,
}

export default memo(StopListItem)
